import { z } from "zod";
import { AccountSchema } from "./Account"; 

export const UpdateAccountRequestSchema = AccountSchema.pick({
  name: true,
  fiscalNumber: true,
  address: true, 
  zipCode: true, 
  city: true,  
  email: true,  
  phoneNumber: true,
  description: true,
});

export type UpdateAccountRequest = z.infer<typeof UpdateAccountRequestSchema>;